const zh = {
  launchKicker: "上线前报名",
  launchTitle: "完整版应用将于 2027 年 2 月 1 日前上线。",
  launchBody: "我们目前正在测试应用并敲定合作协议。现在正是企业、赞助商和市镇报名的好时机——作为首发合作伙伴可享 5 折优惠。",
  launchCta: "立即报名",
  testApp: "试用测试版",
  bandKicker: "企业专区",
  bandTitle: "添加你自己的巨魔——首发合作伙伴享 5 折。",
  bandBody: "酒店、咖啡馆、桑拿、商店和市镇现在就可以报名，在应用上线时让巨魔准备就绪。",
  bandCta: "报名成为合作伙伴",
  kicker: "报名",
  title: "把你的巨魔放上地图。",
  lead: "告诉我们你是谁，选择套餐，并把巨魔放到地图上。你用 Vipps 付款，我们为上线准备好你的巨魔。",
  role: "你是？",
  rolePh: "请选择…",
  roles: { homeowner: "房主或私人接待点", municipality: "市镇、地区或旅游局", sponsor: "赞助商", other: "其他" },
  firstName: "名",
  lastName: "姓",
  company: "公司或组织",
  optional: "选填",
  email: "电子邮箱",
  phone: "电话",
  website: "网站",
  package: "套餐",
  mapTitle: "你想把巨魔放在哪里？",
  mapHint: "搜索你的地址，然后点击地图放置巨魔。拖动图钉可移动位置。",
  search: "搜索挪威的地址或地点",
  searchBtn: "搜索",
  noResults: "未找到地点，请换个关键词。",
  placed: "已放置 {n} / {max} 个巨魔",
  full: "巨魔已全部放置——删除一个即可移动，或选择更大的套餐。",
  noPackage: "请先选择套餐，即可看到能放置多少个巨魔。",
  outside: "巨魔只能放置在挪威境内。",
  pin: "巨魔 {n}",
  remove: "删除",
  message: "还有什么需要我们知道的吗？",
  messagePh: "营业时间、巨魔创意、问题…",
  consent: "我同意 Trollfossjakten 保存这些信息以处理我的报名。请查看{privacy}。",
  submit: "报名并前往付款",
  sending: "发送中…",
  summary: "你的订单",
  pickPackage: "选择套餐即可查看价格。",
  payNote: "报名后使用 Vipps 付款。首发价：第一年 5 折。",
  errors: {
    phone: "请输入有效的电话号码（数字、+、空格）。",
    required: "请填写所有必填项。",
    email: "请输入有效的电子邮箱。",
    pins: "请至少在地图上放置一个巨魔。",
    consent: "请同意我们保存你的信息的方式。",
    tooMany: "此设备报名次数过多，请稍后再试。",
    generic: "出了点问题，请重试。",
  },
  doneKicker: "谢谢！",
  doneTitle: "{name}，你已报名成功。",
  doneBody: "你的订单号是 {ref}。我们已将副本发送至 {email}。使用 Vipps 付款即可锁定首发价。",
  doneBodyNoMail: "你的订单号是 {ref}。请妥善保存——使用 Vipps 付款即可锁定首发价。",
  another: "为另一个地点报名",
  payTitle: "使用 Vipps 付款",
  number: "Vipps 号码",
  amount: "金额",
  ref: "订单号",
  copy: "复制",
  copied: "已复制",
  exVat: "不含增值税价格",
  vat: "增值税 25%",
  total: "应付金额",
  steps: ["打开 Vipps，选择转账", "输入号码 {number}", "输入金额 {amount} 克朗", "在留言中填写订单号 {ref}"],
  invoice: "更想要发票？回复确认邮件，我们会寄给你。",
  host: { name: "接待点", for: "欢迎巨魔猎人并接受巨魔克朗的咖啡馆、农场、小木屋、民宿、桑拿或商店", free: "免费" },
  mapTitleHost: "你的地点在哪里——或者你打算在哪里开业？",
  mapHintHost: "搜索你的地址，然后点击地图放置标记。拖动即可移动。",
  placePin: "你的地点",
  placedHost: "已标记 {n} / 1 个地点",
  fullHost: "你的地点已标记——拖动标记即可移动，或先删除它。",
  placeTitle: "你的地点",
  placeBody: "告诉巨魔猎人你提供什么，并勾选你拥有的所有设施。",
  offer: "你将提供什么？",
  offerPh: "例如：咖啡和华夫饼、桑拿、过夜客房",
  amenitiesTitle: "你有哪些设施？请勾选所有适用项",
  amenities: { coffee: "咖啡", tea: "茶", snacks: "零食", restaurant: "餐厅", conversations: "聊天", phone_charging: "手机充电", bike_charging: "电动自行车充电", car_charging: "电动汽车充电", shower: "淋浴", room: "客房", sauna: "桑拿", bnb: "民宿", hotel: "酒店", camping: "露营", parking: "停车", toilet: "厕所", wifi: "无线网络" },
  hostNote: "成为接待点完全免费——无需付款，也无报名费。我们会核对你的信息并把你的地点放到地图上。",
  submitHost: "注册为接待点",
  offerError: "请告诉我们你将提供什么。",
  hostDoneTitle: "{name}，你已注册为接待点。",
  hostDoneBody: "你的参考编号是 {ref}。我们已将副本发送至 {email}。我们会核对你的信息并把你的地点放到地图上。",
  hostDoneBodyNoMail: "你的参考编号是 {ref}。请妥善保存——我们会核对你的信息并把你的地点放到地图上。",
  hostNextTitle: "接下来",
  hostNext: ["下载应用并用同一邮箱登录。", "前往 个人资料 → 成为接待点，开始接受巨魔克朗。", "扫描客人的付款二维码——应用会自动算出剩余应付金额。"],
  hostGetApp: "下载应用",
};

export default zh;
